import { TIME_PERIOD, UPDATE_OPERATION } from "./constants";
import moment from "moment";
moment.locale("pt-br");

export const normalizeServiceRequest = (
  values,
  requestId,
  serviceOrder,
  { cnl }
) => {
  const cnlCode = cnl.length > 0 ? cnl : "32549";

  return {
    executionDate: moment(values.datePicker).format("DD-MM-YYYY"),
    serviceOrder: serviceOrder,
    cnlCode: cnlCode,
    timeSlot: TIME_PERIOD[values.period],
    appointmentId: requestId,
    contactPhoneNumber: values.phoneNumber,
    notificationType: "MENSAGEM_VOZ_SMS",
    timePeriod: values.period,
    action: UPDATE_OPERATION,
  };
};



// WEBPACK FOOTER //
// ./src/services/state/rescheduling/helpers.js